export class SimpleProduct {
   constructor(id, name, stock, line_id, presentation_id, brand_id, category_id, box_pieces, price, iva, ieps, cost){
      this.id = id
      this.name = name
      this.stock = stock
      this.line_id = line_id
      this.presentation_id = presentation_id
      this.brand_id = brand_id
      this.category_id = category_id

      this.box_pieces = box_pieces

      this.price = price
      this.iva = iva
      this.ieps = ieps
      this.cost = cost
   }

   static fromServiceSimpleProduct (prod) {
      return new SimpleProduct(
         prod.id,
         prod.nombre,
         prod.stock,
         prod.id_linea,
         prod.id_presentacion,
         prod.id_marca,
         prod.id_categoria,

         prod.piezas_paquete,

         prod.precio,
         prod.iva,
         prod.ieps,
         prod.importe
      );
   }
}